var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header-of-pages"},[_c('div',{class:_vm.css},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"title"},[_c('h1',[_vm._v(_vm._s(_vm.headerName))])]),_vm._v(" "),(_vm.showBtn)?_c('a',{staticClass:"btn-back",attrs:{"href":_vm.btnRoute}},[_vm._v(_vm._s(_vm.btnName))]):_vm._e()])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-21105f90","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/pages/components/default/pageHeader.vue
// module id = 892
// module chunks = 0